var _circle, _path, _line, _line2, _line3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionDepression(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 375,
    viewBox: "0 0 290 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.833,
    cy: 144.833,
    r: 144.833,
    fill: "url(#paint0_radial_1486_9773)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.405 355.157H90.3545V350.143H142.405V355.157ZM119.205 374.708H113.27V353.189H119.205V374.708ZM116.253 319.959C120.252 319.959 123.785 320.478 126.854 321.515C129.922 322.53 132.291 324.001 133.963 325.926C135.656 327.831 136.502 330.073 136.502 332.655C136.502 335.13 135.656 337.31 133.963 339.193C132.291 341.076 129.922 342.536 126.854 343.573C123.785 344.588 120.252 345.096 116.253 345.096C112.254 345.096 108.72 344.588 105.652 343.573C102.605 342.536 100.236 341.076 98.543 339.193C96.8503 337.31 96.0039 335.13 96.0039 332.655C96.0039 330.073 96.8503 327.831 98.543 325.926C100.236 324.001 102.605 322.53 105.652 321.515C108.72 320.478 112.254 319.959 116.253 319.959ZM116.253 324.847C113.439 324.847 110.974 325.154 108.858 325.768C106.742 326.381 105.102 327.28 103.938 328.465C102.796 329.65 102.225 331.047 102.225 332.655C102.225 334.199 102.796 335.554 103.938 336.717C105.102 337.86 106.742 338.749 108.858 339.383C110.974 339.997 113.439 340.304 116.253 340.304C119.067 340.304 121.543 339.997 123.68 339.383C125.817 338.749 127.457 337.86 128.599 336.717C129.763 335.554 130.345 334.199 130.345 332.655C130.345 331.047 129.763 329.65 128.599 328.465C127.457 327.28 125.817 326.381 123.68 325.768C121.543 325.154 119.067 324.847 116.253 324.847ZM175.445 353.158H169.446V344.652H175.445V353.158ZM172.525 318.436C176.799 318.436 180.449 318.817 183.475 319.579C186.5 320.34 188.807 321.462 190.394 322.943C192.002 324.403 192.806 326.17 192.806 328.243C192.806 330.338 192.002 332.115 190.394 333.575C188.807 335.035 186.5 336.146 183.475 336.908C180.449 337.669 176.799 338.071 172.525 338.114C168.251 338.071 164.59 337.669 161.543 336.908C158.518 336.146 156.19 335.035 154.561 333.575C152.953 332.115 152.149 330.338 152.149 328.243C152.149 326.17 152.953 324.403 154.561 322.943C156.19 321.462 158.518 320.34 161.543 319.579C164.59 318.817 168.251 318.436 172.525 318.436ZM172.525 322.975C169.478 322.975 166.907 323.186 164.812 323.609C162.739 324.033 161.163 324.625 160.083 325.387C159.004 326.148 158.465 327.101 158.465 328.243C158.465 329.407 158.994 330.38 160.052 331.163C161.11 331.946 162.686 332.538 164.781 332.94C166.875 333.342 169.457 333.565 172.525 333.607C175.593 333.565 178.174 333.342 180.269 332.94C182.364 332.538 183.94 331.946 184.998 331.163C186.077 330.38 186.617 329.407 186.617 328.243C186.617 327.101 186.077 326.148 184.998 325.387C183.919 324.625 182.332 324.033 180.237 323.609C178.143 323.186 175.572 322.975 172.525 322.975ZM198.455 346.239H146.595V341.478H198.455V346.239ZM191.885 364.425H158.814V370.741H152.879V360.077H185.982V355.602H152.784V351.095H191.885V364.425ZM193.536 374.137H152.879V369.471H193.536V374.137Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 114.966,
    y1: 106.572,
    x2: 69.6699,
    y2: 124.964,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -3,
    x2: 51.8875,
    y2: -3,
    transform: "matrix(0.926539 0.376198 0.376198 -0.926539 173.047 102.664)",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 113.894,
    y1: 193.254,
    x2: 175.796,
    y2: 193.493,
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1486_9773",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.833 144.833) rotate(90) scale(144.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D8DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionDepression);
export default __webpack_public_path__ + "static/media/IconEmotionDepression.aaa1b7a10a3a967718ec08423b65daac.svg";
export { ForwardRef as ReactComponent };